import {Box, Card, CardContent, Stack} from '@mui/material';

const AdminHeaderCard = ({
  title,
  titleCmpt,
  child,
}: {
  title: string;
  titleCmpt?: JSX.Element;
  child: JSX.Element;
}) => {
  return (
    <Box className='px-10 py-5 h-full'>
      {titleCmpt ? (
        <Stack
          direction='row'
          className='px-10 min-h-65 blue-variant17 radius-10-0 h-65'
          alignItems='center'
          justifyContent='space-between'>
          <h4 aria-level={2} className='font-bolder m-0 text-white-50'>
            {title}
          </h4>
          {titleCmpt}
        </Stack>
      ) : (
        <Stack
          className='px-10 min-h-65 blue-variant17 radius-10-0 h-65'
          justifyContent='center'>
          <h4 aria-level={2} className='font-bolder m-0 text-white-50'>
            {title}
          </h4>
        </Stack>
      )}
      <Card className='blue-variant50 calcheight-75'>
        <CardContent className='px-10 py-5 partner-station h-full'>
          {child}
        </CardContent>
      </Card>
    </Box>
  );
};

export default AdminHeaderCard;
